export default function(x) {
  return x < 1 ? '< 1' : x
}
